import { initialRolesState, actions } from "./action";

export const RolesReducer = (state = initialRolesState, action) => {
    switch (action.type) {
        case actions.ROLES_GET_ALL_SUCCESS:
            return {
                ...state,
                rolesList: action.payload ?  action?.payload : null
            };
        case actions.ROLES_UPDATE_SUCCESS:
            return {
                ...state,
                rolesDetails: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.ROLES_CREATE_SUCCESS:
            return {
                ...state,
                rolesDetails: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.ROLES_DELETE_SUCCESS:
            return {
                ...state,
                rolesDetails: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.ROLES_RESET_SUCCESS:
            return {
                ...state,
                rolesDetails: {},
                filters: {}
            };
        case actions.ROLES_SET_FILTERS_REQUEST:
            return {
                ...state,
                filters: action.payload || {}
            };
        default:
            return state;
    }
};
